module.exports = __webpack_public_path__ + "img/p6-p1-yu1.207e27c0.png";